import { useContext } from 'react';
import getContext from '../context/AppSettingsContext';
import { useAppSettingsStateStore } from '../context/AppSettingsStateContext';

export const useAppSettings = () => {
    // Always call all hooks unconditionally, in the same order
    const { isGettingAppSettings } = useAppSettingsStateStore();

    // Get the context dynamically
    const AppSettingsContext = getContext();

    // Only call useContext if the context exists; otherwise return a fallback
    const contextSettings = AppSettingsContext ? useContext(AppSettingsContext) : null;

    return {
        settings: contextSettings,
        isLoading: isGettingAppSettings,
    };
};
